<template>
    <div>
        <div class="row" :class="searchType === 'Smart' ? 'mb-0' : 'mb-1'">
            <div class="col-lg-2 col-sm-12 col-md-4 col-xs-12" :class="{'col-lg-8  mb-3': selectedPerson}">
                <div class="search-results-section" v-if="!selectedPerson">
                    <div class="title-container">
                        <div class="page-title" :class="{'quick-search': searchType === 'Smart'}">Search Results
                        </div>
                        <div class="sub-title">
                          <div v-if="this.publicationCountNote !== ''">
                            {{this.publicationCountNote}}
                          </div>
                          <div v-else>
                            {{subTitle}}
                          </div>                          
                          <div class="sub-note" v-html="subNote" v-if="subTitle"></div>
                          <div v-if="$parent.countLoader" class="loading"><span class="loader">Loading...</span></div>
                        </div>
                    </div>
                </div>
                <div class="full-row" v-else-if="selectedPerson">
                    <div class="title-container">
                        <div>
                            <span class="page-title has-modifier">{{selectedPersonRole}}</span>
                            <!-- <svgicon name="arrow-right-thin" class="title-divider"/> -->
                            <span class="page-title-modifier">&ndash; {{selectedPerson.name}}</span>
                        </div>
                        <div class="sub-title">
                            <template v-if="$store.state.searchMeta">
                                {{$store.state.searchMeta.total | addCommas}} Active Project<template v-if="$store.state.searchMeta.total !== 1">s</template>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12  col-sm-12 col-md-8" :class="selectedPerson ? 'col-lg-4 mb-3' : 'col-lg-10'">
                <div class="row">
                    <div class="col-lg-7 col-md-12 mt-1" v-if="$route.query && $route.query.shared  && $route.query.legacy">
                        <div class="alert alert-warning font-weight-bold">
                            Search results may differ slightly from Legacy RePORTER
                        </div>
                    </div>
                    <div class="text-end mt-1 col-md-12" :class="$route.query && $route.query.shared  && $route.query.legacy ? 'col-lg-5': 'col-lg-12'">
                            <template v-if="(!$store.state.editSearchResults || ($store.state.editSearchCriteria))">
                                <b-button
                                    @click.prevent="$refs.searchCriteria.showEditSearchCriteriaForm();"
                                    v-show="!$parent.isLoadingSearchCriteria && (!isEmpty($store.state.editSearchCriteria) || !isEmpty($store.state.searchCriteria))"
                                    v-if="$route.name !== 'publications' && $route.name !== 'patents' && $route.name !== 'clinicalStudies' && $route.name !== 'news'"
                                    variant="link"
                                    class="me-2 text-white"
                                    v-b-tooltip.hover="'Looking to Save this Search?  Click here to view the Save Search Form.'"
                                >
                                    <i class="fas fa-save"></i>
                                    <span class="btn-text ms-2 font-weight-bold">Save...</span>
                                </b-button>
                            </template>

                            <template v-if="(!$store.state.editSearchResults || ($store.state.editSearchCriteria)) && searchType !== 'Smart'">
                                <b-button
                                    @click.prevent="$refs.searchCriteria.showEditSearchCriteriaForm();"
                                    v-show="!$parent.isLoadingSearchCriteria && (!isEmpty($store.state.editSearchCriteria) || !isEmpty($store.state.searchCriteria))"
                                    v-if="$route.name !== 'publications' && $route.name !== 'patents' && $route.name !== 'clinicalStudies' && $route.name !== 'news'"
                                    variant="light"
                                    class="me-2 mb-1"
                                >
                                    <i class="fas fa-pen"></i>
                                    <span class="btn-text ms-2 font-weight-bold">Edit Search Criteria</span>
                                </b-button>
                            </template>


                            <b-button
                                @click.prevent="initExport()"
                                v-if="$route.name !== 'charts'"
                                class=" mb-1"
                                :disabled="!hasData"
                                :class="{'disabled': !hasData}"
                                variant="light">
                                    <i class="fas fa-download"></i>
                                    <span class="btn-text ms-2 font-weight-bold">Export</span>
                                    <div class="loader export-loader" v-if="isExportingFile"></div>
                            </b-button>

                            <b-dropdown v-else-if="$route.name === 'charts'" variant="light" right class=" mb-1">
                                <template v-slot:button-content>
                                    <i class="fas fa-download"></i>
                                    <span class="btn-text ms-2 font-weight-bold">Export</span>
                                </template>

                                <b-dropdown-item href @click.prevent="exportData('chart')" rel="noopener">Export Chart As Image</b-dropdown-item>
                                <b-dropdown-item href v-if="$parent.$refs.Charts && $parent.$refs.Charts.chartType !== 'circle'" @click.prevent="exportData('table')" rel="noopener">Export Data As CSV</b-dropdown-item>

                            </b-dropdown>

                            <b-dropdown variant="light" class="ms-2 mb-1" right>
                                <template v-slot:button-content>
                                    <i class="fas fa-link"></i>
                                    <span class="btn-text ms-2 font-weight-bold">Share</span>
                                </template>
                                    <b-dropdown-item id="emailLink" v-bind:href="shareEmailURL" @click="shareQuery('email')" rel="noopener">Email</b-dropdown-item>
                                    <b-dropdown-item href @click.prevent="shareQuery('copy')" rel="noopener">Copy Link</b-dropdown-item>
                            </b-dropdown>

                    </div>


                </div>
            </div>

        </div>
        <searchCriteria  ref="searchCriteria" v-if="!selectedPerson"/>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import bus from '@/shared/event-bus.js';
import searchCriteria from '@/components/global/searchCriteria.vue';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
    name: 'searchResultsMenu',
    components: {
      searchCriteria
    },
    computed: {
        ...mapGetters([
            'searchType',
            'isExportingFile',
            'selectedPerson',
            'currentQueryDetails',
            'coreProjCountPub',
            'publicationsFacetData'
        ]),
        selectedPersonRole: function () {
            switch (this.selectedPerson.role) {
                case 'pi':
                    return 'PI/Project Leader';
                case 'po':
                    return 'PO/Program Official';
            }
        },
        hasData: function () {
            switch (this.$route.name) {
                case 'list':
                    if (this.$store.state.searchResults && this.$store.state.searchResults.length > 0) {
                        return true;
                    }
                    break;
                case 'publications':
                    if (this.$store.state.publicationResults && this.$store.state.publicationResults.results.length > 0) {
                        return true;
                    }
                    break;
                case 'patents':
                    if (this.$store.state.patentResults && this.$store.state.patentResults.results.length > 0) {
                        return true;
                    }
                    break;
                case 'clinicalStudies':
                    if (this.$store.state.clinicalStudyResults && this.$store.state.clinicalStudyResults.results.length > 0) {
                        return true;
                    }
                    break;
            }
            return false;
        },
        subTitle: function () {
            switch (this.$route.name) {
                case 'list':
                    if (this.$store.state.searchMeta) {
                        return addCommas(this.$store.state.searchMeta.total) + ' Project' + (this.$store.state.searchMeta.total > 1 ? 's' : '');
                    }
                    return '';
                case 'publications':
                    if (this.publicationsFacetData != null) {
                        if (this.publicationsFacetData.total) {
                            var text = addCommas(this.publicationsFacetData.total);

                            text += ' Publication' + (this.publicationsFacetData.total !== 1 ? 's' : '');
                            return text;
                        }
                    }
                    this.$parent.countLoader = false;
                    return '';
                case 'patents':
                    if (this.$store.state.patentResults && this.$store.state.patentResults.meta.total) {
                        return addCommas(this.$store.state.patentResults.meta.total) + ' patent' + (this.$store.state.patentResults.meta.total > 1 ? 's' : '');
                        this.$parent.countLoader = false;
                    }
                    return '';
                case 'clinicalStudies':
                    if (this.$store.state.clinicalStudyResults && this.$store.state.clinicalStudyResults.meta.total) {
                        return addCommas(this.$store.state.clinicalStudyResults.meta.total) + ' Clinical Trial ' + (this.$store.state.clinicalStudyResults.meta.total > 1 ? 'Studies' : 'Study');
                    }
                    return '';
                case 'charts':
                    if (this.$store.state.graphData && this.$store.state.graphData.meta.total) {
                        return addCommas(this.$store.state.graphData.meta.total) + ' Project' + (this.$store.state.graphData.meta.total > 1 ? 's' : '');
                    }
                    return '';
                default:
                    return '';
            }
        },
        subNote: function () {
            var text = '';

            if (this.$route.name === 'publications') {
                if (this.coreProjCountPub) {
                    text = 'supported by ' + addCommas(this.coreProjCountPub) + ' core projects';

                    if (this.externalURLs && this.externalURLs.reporter_project_search_max_core_projects_limit) {
                        if (this.coreProjCountPub > this.externalURLs.reporter_project_search_max_core_projects_limit) {
                            text += '<br />(publications list truncated due to too many projects)';
                        }
                    }
                    this.$parent.countLoader = false;
                }
            } else {
                this.$parent.countLoader = false;
            }

            return text;
        }
    },
    watch: {
        '$route.fullPath': function (val) {
            if (val) {
                this.setShareURL();
            }
        }
    },
    data: function () {
        return {
            serverless: false,
            data: null,
            isLoadingSearchCriteria: false,
            shareEmailURL: '',
            shareCopyURL: '',
            publicationCountNote: ""
        };
    },
    mounted () {
      if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
        this.$router.push({ path: '/' });
      } else {
        this.setShareURL();
        bus.$on("publication_count", (pn) => {
          this.publicationCountNote = pn;
        });
            //from edit link, show the crit form (from store) and then clear it...
            if(this.currentQueryDetails && this.currentQueryDetails.showCriteria)   {
                this.showCriteria = true;
                delete this.currentQueryDetails.showCriteria;
            }
        }

        this.setFullscreen(true);
    },
    methods: {
        ...mapActions([
            'setFullscreen',
            'setEditSearchResultsFlag',
            'setLookup',
            'setSearchMode',
            'setSearchType',
            'setExportCriteria',
            'setCurrentQueryDetailsAction'
        ]),
        setShareURL () {
            var bodyMsg = 'Please click on link to view list of NIH-funded research projects ',
                mailText,
                subject = 'NIH RePORTER - Hitlist link',
                curURL = '';

            if (!this.selectedPerson) {
                curURL = location.href.indexOf('shared=true') === -1 ? (location.href + (location.href.indexOf('?') !== -1 ? '&' : '?') + 'shared=true') : location.href;


            } else {
                if (this.selectedPerson.role === 'pi') {
                    curURL = location.origin + '/PISearch/' + this.selectedPerson.profile_id;
                } else if (this.selectedPerson.role === 'po') {
                    curURL = location.origin + '/POSearch/' + this.selectedPerson.name;
                }
            }


            switch (this.$route.name) {
                case 'charts':
                    subject = 'NIH RePORTER - Hitlist visualization link';
                    break;
                case 'publications':
                    subject = 'NIH RePORTER - Publication Hitlist link';
                    break;
                case 'patents':
                    subject = 'NIH RePORTER - Patent Hitlist link';
                    break;
                case 'clinicalStudies':
                    subject = 'NIH RePORTER - Clinical Studies Hitlist link';
                    break;
            }

            curURL = curURL.replace(/%/g, '%25').replace(/\&/g, '%26');
            mailText = ('mailto:?subject=' + subject + '  &body=' + bodyMsg + ' %0A%0A ' + curURL).replace(/\s/g, '%20');

            this.shareEmailURL = mailText;
            this.shareCopyURL = curURL;
        },
        initExport () {
            bus.$emit('export:init');
        },
        isEmpty (obj) {
            // null and undefined are "empty"
            if (obj == null) return true;

            // Assume if it has a length property with a non-zero value
            // that that property is correct.
            if (obj.length > 0)    return false;
            if (obj.length === 0)  return true;

            // If it isn't an object at this point
            // it is empty, but it can't be anything *but* empty
            // Is it empty?  Depends on your application.
            if (typeof obj !== "object") return true;

            // Otherwise, does it have any properties of its own?
            // Note that this doesn't handle
            // toString and valueOf enumeration bugs in IE < 9
            for (var key in obj) {
                if (hasOwnProperty.call(obj, key)) return false;
            }

            return true;
        },
        exportData(dataType) {
            this.$parent.$refs.Charts.export(dataType);
        },
        shareQuery (type) {
            if (!this.selectedPerson) {
                try {
                    this.$parent.saveSharedSearchID(type);
                } catch (err) {
                    console.error(err);
                }
            }
            switch (type) {
                case 'email':

                    //GA
					gtag('event', 'Click', {
						'event_category': (this.$route.name === 'list' ? 'Search' : this.$route.name) + '  Results',
						'event_label': 'Email Link',
						'value': 'Email Link'
					});	
                    break;
                case 'copy':
                    try {
                        let reportLinkInput = document.createElement('input');

                        reportLinkInput.setAttribute('id', 'report-link');
                        reportLinkInput.value = this.shareCopyURL;
                        reportLinkInput.style.opacity = '0';
                        document.body.appendChild(reportLinkInput);

                        reportLinkInput.select();
                        var successful = document.execCommand('copy');

                        reportLinkInput.parentNode.removeChild(reportLinkInput);

                        if (successful) {
                            toast.success(`<strong>Success</strong>\nLink Copied`, {
                                autoClose: 2000, 
                                dangerouslyHTMLString: true,
                                closeButton: true,
                                pauseOnHover: false
                            });
                        }
                    } catch (err) {
                        // $('#copy-msg').html(('Oops, unable to copy'));
                    }
                    //GA
					gtag('event', 'Click', {
						'event_category': (this.$route.name === 'list' ? 'Search' : this.$route.name) + '  Results',
						'event_label': 'Copy Link',
						'value': 'Copy Link'
					});	
            }
        }
    }

}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
.criteria-container {
    display: inline-block;
    vertical-align: top;
    position: relative;
    background-color: transparent;
    padding: 5px 10px 0;
    .display-criteria {
        max-height: 60px;
        overflow: hidden;
        // margin-bottom: 10px;
        display: inline-block;
        &.expanded {
            max-height: 100%;
            overflow: auto;
            display: inline;
        }
    }

    a {
        color: $white;
        text-decoration: underline;
        // margin: 0 15px;
        margin: 0;
        &.expanded {
           margin: 0 15px;
        }
    }

    .show-more-less {
        margin-left: 15px;
        &.new-line {
            float: right;
            margin-left: 0px;
        }
        a {
            // display: none;
            position: absolute;
            bottom: 0px;
            left: -120px;
            &.display-link {
                display: inline-block;
            }
        }
    }
}


.title-container {
    position: relative;
    min-height: 60px;
    .loader {
        top: 6px;
        height: 7em;
        width: 7em;
        left: 5%;
    }
}

.search-criteria-section {
    width: calc(100% - 210px);
}

.criteria-container {
    padding-right: 185px;

    .show-more-less {
        position: absolute;
        right: 10px;
        bottom: 5px;
    }
}

</style>
